import React, { useEffect, useState } from 'react';
import localforage from 'localforage';
import { failedCSVImportStorageKey } from '@repo/redux/actions/csvImport';
import { useTextCopiedTimer } from '@repo/hooks';
import Container from '@components/ContentContainer';
import Header from '@components/Header';
import { SettingsInlineButton } from '@views/Settings/components';

const FailedUpload = ({ importID, contacts, clearFailedUpload }) => {
  const dataString = JSON.stringify(contacts);
  const [textCopied, copyTextToClipboard] = useTextCopiedTimer(
    `Import ${importID} -- ${dataString}`,
  );

  return (
    <li>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        }}
      >
        <h4 style={{ margin: 0 }}>Import ID: {importID}</h4>
        <SettingsInlineButton className="btn-muted" onClick={copyTextToClipboard}>
          {textCopied ? 'Data copied' : 'Copy data to clipboard'}
        </SettingsInlineButton>
        <SettingsInlineButton className="btn-muted" onClick={clearFailedUpload}>
          Clear Data
        </SettingsInlineButton>
      </div>
      <pre
        style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
          padding: 16,
          backgroundColor: 'var(--borderColor)',
          fontSize: 12,
          borderRadius: 4,
        }}
      >
        {dataString}
      </pre>
    </li>
  );
};

export default function ImportFailures() {
  const [failedUploads, setFailedUploads] = useState([]);

  const clearFailedUpload = (importID: string) => {
    const updatedFailedUploads = failedUploads.filter(([id]) => id !== importID);
    localforage.setItem(failedCSVImportStorageKey, Object.fromEntries(updatedFailedUploads));
    setFailedUploads(updatedFailedUploads);
  };

  useEffect(() => {
    localforage.getItem(failedCSVImportStorageKey).then((failures) => {
      if (failures) {
        setFailedUploads(Object.entries(failures));
      }
    });
  }, []);

  return (
    <Container>
      <Container.Primary header={<Header>Import Failures</Header>}>
        <div
          style={{
            padding: '8px 35px 20px',
          }}
        >
          {failedUploads.length === 0 ? (
            <p>No stored import failures found</p>
          ) : (
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {failedUploads.map(([importID, contacts]) => (
                <FailedUpload
                  key={importID}
                  importID={importID}
                  contacts={contacts}
                  clearFailedUpload={() => clearFailedUpload(importID)}
                />
              ))}
            </ul>
          )}
        </div>
      </Container.Primary>
    </Container>
  );
}
